<template>
  <!-- <pre v-if="responseData"> test={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PENGUATKUASAAN PBT.png"
        alt="PENGUATKUASAAN PBT"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>

 
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>JUMLAH TINDAKAN PENGUATKUASAAN PBT {{ formattedStateTitle }} MENGIKUT JENIS KESALAHAN {{ selectedYear }}</h2>
      <div class="chart-wrapper">  
        <ChartBar
          :x-axis-data="TindakanChartData"
          :series-data="TindakanChartNames"
        />
      </div>


      <h2>PERATUSAN TINDAKAN PENGUATKUASAAN PBT {{ formattedStateTitle }} MENGIKUT JENIS KESALAHAN {{ selectedYear }}</h2>
      <div class="chart-wrapper">  
        <DonutChart :chart-data="peratusanTindakan" />
      </div>  
      

      <!-- eProfil -->
      <!--
        <h2>JUMLAH  PENGUATKUASAAN PBT {{ formattedStateTitle }} MENGIKUT NEGERI {{ selectedYear }}</h2>
        <div class="chart-wrapper">  
        <Bar
        :chart-data="[1200, 1300, 1400, 1600, 1900, 2000, 2300, 2800, 3200, 3500]"
        :chart-categories="['Johor', 'Kedah', 'Kelantan', 'Melaka', 'Negeri Sembilan', 'Pahang', 'Perak', 'Perlis', 'Sabah', 'Sarawak']"
        :chart-colors="['#42a5f5']"
        y-axis-title=""
        />
        </div> 
      -->
    </div>
    <PrimaryModule />
    <InspektoratMenu />
  </AdminBackground>
</template>

<script setup>
import DonutChart from '@/components/chart/DonutChart.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref, watch } from 'vue'


//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})





const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const TindakanChartData = ref([])
const TindakanChartNames = ref([])
const peratusanTindakan = ref([])

function stringWithoutSym(value) {
  if (typeof value !== 'string') {
    console.warn("Invalid input for stringWithoutSym:", value)
    
    return ''
  }
  
  return value.replace(/[^\w\s]/g, '')
}

const displayNameMapping = {
  // eslint-disable-next-line camelcase
  kesalahan_trafik: "Akta 333 - Kesalahan Trafik",
  // eslint-disable-next-line camelcase
  jalan_parit_bangunan: "Akta 133 - Kesalahan Jalan, Parit & Bangunan",
  // eslint-disable-next-line camelcase
  uuk_iklan: "Akta 171 - UUK Iklan",
  // eslint-disable-next-line camelcase
  uuk_spa: "Akta 171 - UUK Spa",
  // eslint-disable-next-line camelcase
  bengkel_haram: "Akta 171 - Bengkel Haram",
  // eslint-disable-next-line camelcase
  penjaja_gerai_haram: "Akta 171 - Penjaja Gerai Haram",
  // eslint-disable-next-line camelcase
  kilang_haram: "Akta 171 - Operasi Kilang Haram",
  // eslint-disable-next-line camelcase
  operasi_premis_hiburan: "Akta 171 - Operasi Premis Hiburan",
  // eslint-disable-next-line camelcase
  operasi_jual_arak: "Akta 171 - Operasi Penjualan Arak",
  // eslint-disable-next-line camelcase
  operasi_haiwan_anjing: "Akta 171 - Operasi Haiwan/Anjing Liar",
  // eslint-disable-next-line camelcase
  operasi_warga_asing: "Akta 171 - Operasi Warga Asing",

}

function filterSpecificData(data) {
  const categoriesToDisplay = [
    "kesalahan_trafik",
    "jalan_parit_bangunan",
    "uuk_iklan",
    "uuk_spa",
    "bengkel_haram",
    "penjaja_gerai_haram",
    "kilang_haram",
    "operasi_premis_hiburan",
    "operasi_jual_arak",
    "operasi_haiwan_anjing",
    "operasi_warga_asing",
  ]

  return Object.entries(data)
    .filter(([name]) => categoriesToDisplay.includes(name))
    .map(([name, value]) => ({ name: displayNameMapping[name], value }))
}

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)


async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = Array.isArray(state) ? state : [state]

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }


    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {

      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }


    const url = `inspektorat/penguatkuasaan-pbt?${queryParams}`

    const response = await httpGet(url)

    years.value = response.data_information.years

  
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response

    const tindakan = response.data.keseluruhan


    const filteredData = filterSpecificData(tindakan)

    TindakanChartData.value = filteredData.map(item => item.name) 
    TindakanChartNames.value = filteredData.map(item => item.value)
    peratusanTindakan.value = filteredData 

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState is an array
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (state) {
        pbt.value.push(...councils.value[state].map(council => council.value))
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state]) {
        console.log('Adding councils for state:', state, councils[state])
        pbt.value.push(...councils.value[state].map(council => council.value))
      } else {
        console.warn(`No councils found for state: ${state}`)
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}


const formattedStateTitle = computed(() => {
  if (selectedsState.value.length === 1) {

    return selectedsState.value[0] === 'Semua Negeri'
      ? 'MALAYSIA' 
      : stringWithoutSym(selectedsState.value[0].toUpperCase())
  }
  

  return selectedsState.value.join(', ').toUpperCase()
})



onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })

watch(selectedsState, newState => {
  console.log('Selected State Changed:', newState)
  loadDataFromApi(selectedYear.value, newState)  // Reload the data based on the new state
})


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}
/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}


.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); /* Shadow for depth */
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

.item-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background: rgba(255, 255, 255, 80%); /* Background for content */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); /* Shadow for depth */
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

h1 {
  position: relative;
  color: white;
  font-size: 2rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block-end: 20px;
  text-align: center;
}

h1::after {
  display: block;
  border-radius: 3px;
  background-color: white;
  block-size: 5px;
  content: "";
  inline-size: 40%;
  margin-block: 10px 0;
  margin-inline: auto;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
}

.title-main {
  color: darkblue;
  font-size: 2rem;
  font-weight: bold;
  margin-block-end: 0;
  text-align: center;
}

.title-sub {
  color: darkblue;
  font-size: 1.5rem;
  font-weight: bold;
  margin-block-end: 10px;
  text-align: center;
}

.filter-wrapper {
  display: flex;
  gap: 10px;
  margin-block-end: 20px;
}

.filter-box label {
  color: black;
  font-weight: bold;
  margin-block-end: 5px;
}

.filter-box input,
.filter-box select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: white;
  inline-size: 100%;
}

.content {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(4, 1fr);
  inline-size: 100%;
}

.box {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  block-size: 100px;
  inline-size: 100%;
  transition: transform 0.3s;
}

.box:hover {
  transform: translateY(-5px);
}

.box p,
.box .count {
  color: white;
  font-weight: bold;
  text-align: center;
}

.box p {
  font-size: 1rem;
}

.box .count {
  font-size: 2rem;
}

.my-5 {
  margin-block: 1.25rem;
  margin-inline: 0;
}

/* Add the chart-wrapper class */
.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 0.8);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}
</style>
